// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-56848ea2]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.message_content[data-v-56848ea2] {\n  position: relative;\n}\n.right-btn[data-v-56848ea2] {\n  position: absolute;\n  top: 24px;\n  right: 40px;\n  z-index: 2;\n}", ""]);
// Exports
module.exports = exports;
